import PropTypes from 'prop-types';
import useStyles from './useStyles';
import cx from 'classnames';
import { useUpgradePopup } from 'src/services/popup';
import { FEATURE_LIMITS } from 'src/data/featureLimits';

export const InlineUpgradeButton = ({
  className,
  dataTestId,
  text,
  actionsOrigin = '',
  upgradeUrl = '',
}) => {
  const styles = useStyles();
  const openUpgradePopup = useUpgradePopup({ actionsOrigin });

  const handleUpgradeClick = () => {
    if (upgradeUrl) {
      window.open(upgradeUrl, '_blank');
      return;
    }
    openUpgradePopup(FEATURE_LIMITS.resourcesRowsPerCustomer);
  };

  return (
    <span
      data-testid={`inlineUpgradeButton_${dataTestId}`}
      className={cx(styles.root, className)}
      onClick={handleUpgradeClick}
    >
      {text || 'Upgrade'}
    </span>
  );
};
InlineUpgradeButton.displayName = 'InlineUpgradeButton';
InlineUpgradeButton.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  upgradeUrl: PropTypes.string,
  text: PropTypes.string,
  actionsOrigin: PropTypes.string,
};

InlineUpgradeButton.defaultProps = {
  className: null,
  text: null,
  dataTestId: '',
  upgradeUrl: null,
  actionsOrigin: '',
};
